// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3hSlt","label":"Completed_label__tTmRg"};